import { AuthState } from '.';
import type { RootState } from '..';
import { Routes } from '../../routes.types';

export const getAuthState = (state: RootState): AuthState => state.auth;
export const getAuthMessage = (state: RootState): string => state.auth.message ?? '';
export const getIsAuthenticated = (state: RootState): boolean => state.auth.isAuthenticated;
export const getBeforeLoginRoute = (state: RootState): Routes | null => state.auth.beforeLoginRoute;
